var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"van-field-border mb-2",class:_vm.transitionClass},[_c('van-field',{attrs:{"readonly":"","right-icon":"arrow-down","value":_vm.value,"placeholder":_vm.finalPlaceholder},on:{"click":_vm.onClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }